module.exports = __webpack_public_path__ + "media/images/teams/UDINESE-bb7877441269911fecb2882bdb742b2b.png";